export default "assets/images/logo-black-83d82fac.svg";